import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- Theme Settings -------------------------------------------*
  // *===============================================---*
  {
    path: '/themeSettings/list',
    name: 'pages-theme-settings-list',
    component: () => import('@/views/pages/themeSettings/ThemeSettingList.vue'),
    meta: {
      resource: 'setting',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('themeSettings.mainVerticalMenu.themeSettings'),
    },
  },
  {
    path: '/themeSettings/add',
    name: 'pages-theme-settings-add',
    component: () => import('@/views/pages/themeSettings/ThemeSettingAdd.vue'),
    meta: {
      resource: 'setting',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('themeSettings.mainVerticalMenu.themeSettings'),
    },
  },
  {
    path: '/themeSettings/edit/:id',
    name: 'pages-theme-settings-edit',
    component: () => import('@/views/pages/themeSettings/ThemeSettingEdit.vue'),
    meta: {
      resource: 'setting',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('themeSettings.mainVerticalMenu.themeSettings'),
    },
  },

  {
    path: '/redirectSetting/list',
    name: 'pages-redirect-settings-list',
    component: () => import('@/views/pages/redirectSetting/RedirectSettingList.vue'),
    meta: {
      resource: 'setting',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('themeSettings.redirectLink.themeSettings'),
    },
  },
  {
    path: '/redirectSetting/add',
    name: 'pages-redirect-settings-add',
    component: () => import('@/views/pages/redirectSetting/RedirectSettingAdd.vue'),
    meta: {
      resource: 'setting',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('themeSettings.redirectLink.themeSettings'),
    },
  },
  {
    path: '/redirectSetting/edit/:id',
    name: 'pages-redirect-settings-edit',
    component: () => import('@/views/pages/redirectSetting/RedirectSettingEdit.vue'),
    meta: {
      resource: 'setting',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('themeSettings.redirectLink.themeSettings'),
    },
  },
]
